"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrimaryColor = exports.PrimaryThemeColorProvider = exports.DEFAULT_PRIMARY_THEME_COLOR = void 0;
const react_1 = __importStar(require("react"));
const theme_1 = require("../theme");
const usePersistedState_1 = require("./usePersistedState");
exports.DEFAULT_PRIMARY_THEME_COLOR = theme_1.HACKER_GREEN_COLOR;
const PrimaryThemeColorContext = react_1.default.createContext({
    primaryColor: exports.DEFAULT_PRIMARY_THEME_COLOR,
    setPrimaryColor: () => {
        return;
    },
});
const PrimaryThemeColorProvider = ({ children }) => {
    const [color, setColor] = (0, usePersistedState_1.usePersistedState)(exports.DEFAULT_PRIMARY_THEME_COLOR, 'PrimaryThemeColor');
    return (react_1.default.createElement(PrimaryThemeColorContext.Provider, { value: {
            primaryColor: color,
            setPrimaryColor: setColor,
        } }, children));
};
exports.PrimaryThemeColorProvider = PrimaryThemeColorProvider;
function usePrimaryColor() {
    return (0, react_1.useContext)(PrimaryThemeColorContext);
}
exports.usePrimaryColor = usePrimaryColor;
//# sourceMappingURL=usePrimaryColor.js.map